<template>
  <div class="vue_template_wrapper">
    <div class="steps_body">
      <app-page-section :title="$t('Parâmetros adicionais')">
        <calc-form-card
          :title="$t('Esforço axial')"
          optional
          v-model="calculation.input.internal.axial"
        >
          <calc-form-item :title="$t('Tipo de carga')" title-style="inline">
            <b-radio-group>
              <b-radio native-value="axialRegular" v-model="axialLoad.type">{{
                $t("Carga axial de dimensionamento")
              }}</b-radio>
              <b-radio native-value="notMajored" v-model="axialLoad.type">{{
                $t("Carga axial não majorada devido à acção do vento")
              }}</b-radio>
            </b-radio-group>
          </calc-form-item>

          <calc-form-item :title="$t('Carga')" title-style="inline">
            <calc-number-input
              class="ui-mb16"
              v-model="displayAxialLoad"
              addon="kN"
              :min="0"
              :max="500"
            />

            <b-radio-group>
              <b-radio native-value="traction" v-model="loadDirectionType">{{
                $t("Tração")
              }}</b-radio>
              <b-radio native-value="compression" v-model="loadDirectionType">{{
                $t("Compressão")
              }}</b-radio>
            </b-radio-group>
          </calc-form-item>
        </calc-form-card>

        <calc-form-card
          optional
          v-model="calculation.input.internal.spanRestraints"
        >
          <template slot="title">
            {{ $t("Travamentos") }}
            <app-tooltip class="m-pad-0">
              <img src="@/assets/img/travamentos.png" />
            </app-tooltip>
          </template>

          <calc-form-item-fibre-upper ref="calcFormItemFibreUpper" />
          <calc-form-item-fibre-lower ref="calcFormItemFibreLower" />
        </calc-form-card>

        <calc-form-card :title="$t('Deformação')">
          <calc-form-item
            :title="$t('Limite')"
            title-style="inline"
            class="ui-mb4"
          >
            <div class="fields_grid">
              <calc-number-input
                v-model.number="calculation.input.deformation.limit"
                :min="1"
                addon="L /"
                addonPosition="left"
                :max="1000"
                :step="100"
                :precision="0"
              />
            </div>
          </calc-form-item>

          <calc-form-item :title="$t('Combinação')" title-style="inline">
            <div class="fields_grid">
              <b-select
                v-model.number="calculation.input.deformation.combination"
              >
                <option
                  v-for="option in combinationOptions"
                  :key="option.val"
                  :value="option.val"
                >
                  {{ $t("input.deformation.combination", option.val) }}
                </option>
              </b-select>
            </div>
          </calc-form-item>
        </calc-form-card>
      </app-page-section>
    </div>

    <div class="steps_nav">
      <b-button
        class="steps_nav__btn"
        @click="$emit('prev')"
        icon-left="arrow-left"
        size="is-medium"
        type="is-primary"
        inverted
        >{{ $t("Voltar") }}</b-button
      >

      <b-button
        class="steps_nav__btn"
        @click="$emit('start-calculation')"
        icon-right="arrow-right"
        size="is-medium"
        type="is-primary"
        >{{ $t("Continuar") }}</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CalcFormItemFibreUpper from "./CalcFormItemFibreUpper";
import CalcFormItemFibreLower from "./CalcFormItemFibreLower";

export default {
  name: "CalcStepAdditional",

  components: {
    CalcFormItemFibreUpper,
    CalcFormItemFibreLower,
  },

  data() {
    return {
      calcFormItemFibreUpper: undefined,
      calcFormItemFibreLower: undefined,
      loadDirectionType: undefined,
      combinationOptions: [{ val: 1 }, { val: 2 }, { val: 3 }],
    };
  },

  computed: {
    ...mapState(["user"]),
    ...mapState("calculator", ["calculation"]),

    axialLoad() {
      return this.calculation.input.loads.find((load) => load.case === "axial");
    },

    displayAxialLoad: {
      set(val) {
        if (this.loadDirectionType === "compression") {
          this.axialLoad.value = -val;
        } else if (this.loadDirectionType === "traction") {
          this.axialLoad.value = val;
        }
      },
      get() {
        return Math.abs(this.axialLoad.value);
      },
    },
  },

  watch: {
    loadDirectionType(loadDirectionType) {
      if (this.axialLoad.value !== 0) {
        if (loadDirectionType === "compression") {
          this.axialLoad.value = -this.displayAxialLoad;
        } else if (loadDirectionType === "traction") {
          this.axialLoad.value = this.displayAxialLoad;
        }
      }
    },
  },

  created() {
    if (this.axialLoad.value < 0) {
      this.loadDirectionType = "compression";
    } else {
      this.loadDirectionType = "traction";
    }
  },
};
</script>
